import { Tabs as TabsMobile } from '@vkontakte/vkui';
import TabsDesktop from './TabsDesktop';
import { getPlatformComponent } from '../utils/getPlatformComponent';
import TabsItem from '../TabsItem';

export default Object.assign(getPlatformComponent({ mobile: TabsMobile, desktop: TabsDesktop }), { Item: TabsItem });
